import React, { createContext, useState, useEffect } from "react";
// import schoolApi from "../api/schoolApi"; // Adjust path based on your project structure
import schoolApi from "../api/schoolApi"; // Adjust path based on your project structure

export const SessionContext = createContext();

export const SessionProvider = ({ children }) => {
  const [sessionYear, setSessionYear] = useState([]);
  const [selectedSessionId, setSelectedSessionId] = useState("");

  useEffect(() => {
    async function fetchSessions() {
      try {
        const sessions = await schoolApi.fetchSessions();
        if (sessions.success) {
          const currentDate = new Date();
          // Find the current session based on date range
          const currentSession = sessions.result?.find((sess) => {
            const startDate = new Date(sess.startdate);
            const endDate = new Date(sess.enddate);
            return currentDate >= startDate && currentDate <= endDate;
          });
          setSessionYear(sessions.result);
          const selectedId = currentSession?.id || sessions.result?.[0]?.id || "";
          console.log("currentSession?.id@@=>", selectedId);
          setSelectedSessionId(selectedId);
        }
      } catch (error) {
        console.error("Error fetching sessions:", error);
      }
    }
    fetchSessions();
  }, []);

  return (
    <SessionContext.Provider
      value={{ sessionYear, selectedSessionId, setSelectedSessionId }}
    >
      {children}
    </SessionContext.Provider>
  );
};
